import React from 'react';
import { Table, Status, CopyToClipboardLink, Dropdown, StopPropagation, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { fetcher } from '@weezevent/weezjs-core';

export default function TicketOfficeEventRow({ ticket_office, ticket_office_operator, organization, onDelete, syncTicketOffice }) {
    const { t } = useTranslation();
    const history = useHistory();
    const toast = React.useContext(ToastContext);

    const closeMySession = React.useCallback(
        id => {
            fetcher
                .get(`/ticket/organizations/${organization.id}/ticket_office/${ticket_office.id}/session/${id}/close_session`)
                .then(() => {
                    toast.success(t('ticket.sales_report.close_session.success'));
                })
                .catch(() => toast.error(t('ticket.sales_report.close_session.error')))
                .finally(() => {
                    syncTicketOffice({
                        allow_cache: false,
                        cache: false
                    });
                });
        },
        [organization, ticket_office, toast, t]
    );

    return (
        <>
            <Table.Tr
                disabled={!ticket_office_operator.active}
                onClick={() => {
                    history.push(`users/${ticket_office_operator.id}`);
                }}
            >
                <Table.Td>{ticket_office_operator.name}</Table.Td>
                <Table.Td>
                    <StopPropagation>
                        <CopyToClipboardLink value={ticket_office_operator.email}>{ticket_office_operator.email}</CopyToClipboardLink>
                    </StopPropagation>
                </Table.Td>
                <Table.Td>
                    <div style={{ width: '100px' }}>
                        <StopPropagation>
                            <CopyToClipboardLink value={ticket_office_operator.password}>{'•'.repeat(10)}</CopyToClipboardLink>
                        </StopPropagation>
                    </div>
                </Table.Td>
                <Table.Td>
                    <DisplayStatus ticket_office_operator={ticket_office_operator} />
                </Table.Td>
                <Table.Td>
                    <StopPropagation>
                        <Dropdown disabled={!ticket_office_operator.active} closeOnDocumentClick>
                            <Dropdown.Item disabled={!ticket_office_operator.active_session} onClick={() => closeMySession(ticket_office_operator.active_session)}>
                                {t('ticket.ticket_offices.operators.action.disabled')}
                            </Dropdown.Item>
                            <Dropdown.Item onClick={onDelete}>{t('ticket.ticket_offices.operators.action.deleted')}</Dropdown.Item>
                        </Dropdown>
                    </StopPropagation>
                </Table.Td>
            </Table.Tr>
        </>
    );
}

function DisplayStatus({ ticket_office_operator }) {
    const { t } = useTranslation();

    const statusColor = React.useMemo(() => {
        return ticket_office_operator.active ? (ticket_office_operator.active_session ? 'green' : 'orange') : 'red';
    }, [ticket_office_operator]);

    const getStatus = ticket_office_operator => {
        return ticket_office_operator.active
            ? ticket_office_operator.active_session
                ? t('ticket.ticket_offices.operators.status.online')
                : t('ticket.ticket_offices.operators.status.offline')
            : t('ticket.ticket_offices.operators.status.close');
    };

    return <Status color={statusColor}>{getStatus(ticket_office_operator)}</Status>;
}
